import s from './FullscreenLoader.module.css';
import { Loader } from '@repo/ui/Loader';
import { Flex } from '@repo/ui/Flex';
import { FullscreenError } from '../FullscreenError/FullscreenError';
import { PageWrap } from '../Page/Page';

export const FullscreenLoader = ({ error }: { error?: boolean }) => {
  if (error) {
    return (
      <PageWrap>
        <FullscreenError />
      </PageWrap>
    );
  }

  return (
    <Flex
      grow="1"
      justifyContent="center"
      alignItems="center"
      className={s.wrapper}
    >
      <div className={s.loader}>
        <Loader size="lg" label="Loading..." />
      </div>
    </Flex>
  );
};
